import Script from 'next/script'
import { memo } from 'react'

interface IPropTypes {
  appId: string
}
function FreshChat({ appId = '' }: IPropTypes) {
  if (!appId) return <></>
  return (
    <Script
      id='freshchat-init'
      strategy='afterInteractive'
      // @ts-ignore
      chat='true'
      src={`//fw-cdn.com/${appId}.js`}
    />
  )
}

export default memo(FreshChat)
